import * as React from "react";
import React__default from "react";
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;
  else if ("object" == typeof e) if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  } else for (f in e) e[f] && (n && (n += " "), n += f);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
const Button = ({
  children,
  type = "button",
  onClick,
  variant = "primary",
  href,
  fullWidth = false,
  icon,
  iconPosition = "left",
  size = "regular",
  iconDivider = false,
  ...rest
}) => {
  const className = clsx("VSButton", `VSButton--${variant}`, {
    "VSButton--fullWidth": fullWidth,
    "VSButton--small": size === "small"
  });
  const contentClassName = clsx("VSButton__content", {
    "VSButton__content--dividerLeft": iconPosition === "left" && iconDivider,
    "VSButton__content--dividerRight": iconPosition === "right" && iconDivider
  });
  const Component = href ? "a" : "button";
  return /* @__PURE__ */ React__default.createElement(
    Component,
    {
      type: !href ? type : void 0,
      onClick,
      className,
      href,
      ...rest
    },
    /* @__PURE__ */ React__default.createElement("span", { className: "VSButton__label" }, icon && iconPosition === "left" && icon, /* @__PURE__ */ React__default.createElement("span", { className: contentClassName }, children), icon && iconPosition === "right" && icon)
  );
};
const SvgIconSelectChevron = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.6031 6.51292C23.1796 7.14373 23.1212 8.10964 22.4726 8.67035L13.4616 16.4596C12.6281 17.1801 11.372 17.1801 10.5384 16.4596L1.52744 8.67035C0.878787 8.10964 0.82036 7.14373 1.39694 6.51292C1.97353 5.88212 2.96678 5.8253 3.61544 6.38602L12 13.6338L20.3846 6.38602C21.0332 5.8253 22.0265 5.88212 22.6031 6.51292Z", fill: "currentcolor" }));
export {
  Button as B,
  SvgIconSelectChevron as S,
  clsx as c
};
